import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Button, Modal } from "react-bootstrap";
import axios, { PublicKey } from "../../API/axios";
import WcOutlinedIcon from '@mui/icons-material/WcOutlined';

import toast from "react-hot-toast";
import UpdateCandidateProfile from "./UpdateCandidateProfile";
import UpdateInstituteProfile from "./UpdateInstituteProfile";
import UpdateCompanyProfile from "./UpdateCompanyProfile";
import UpdateRecruiterProfile from "./UpdateRecruiterProfile";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import ManageCompanies from "../PostJobs/Companies/ManageCompanies";
import ManageComList from "../PostJobs/Companies/ManageComList";


const Setting = () => {
  const sessionId = localStorage.getItem("sessionId");
  const module = localStorage.getItem("Module");


  const navigate = useNavigate();

  // ..........Confim delete account..........
  const [showPass, setShowPass] = useState(false);
  const [showPass1, setShowPass1] = useState(false);

  const [showPass3, setShowPass3] = useState(false);
  const [showPass4, setShowPass4] = useState(false);

  // .................................A ....................................

  const [displays, setDisplays] = useState(false);

  // ............................... A ......................................

  // ..........Confim delete account..........
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDeactivate, setShowDeactivate] = useState(false);

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleShowDeactivate = () => setShowDeactivate(true);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleClose = () => {
    setShow(false);
    setShowDeactivate(false);
    setShow(false);
  };

  //   Modal for unblock
  const [unblockId, setUnblockId] = useState(false);
  const [showUnblock, setShowUnblock] = useState(false);
  const handleShowUnblock = () => setShowUnblock(true);
  const handleCloseUnblock = () => {
    setShowUnblock(false);
  }

  //   Modal for unfollow
  const [unfollowId, setUnfollowId] = useState(false);
  const [showUnfollow, setShowUnfllow] = useState(false);

  const handleShowUnfollow = () => setShowUnfllow(true);
  const handleCloseUnfollow = () => {
    setShowUnfllow(false);
  }

  const handleDelete = async () => {
    try {
      const response = await axios.post(
        `/Account/DeleteAccount?sessionId=${sessionId}`,
        {
          headers: {
            PublicKey,
          },
        }
      );
      console.log("res", response);
      toast.success(response.data.message);
      handleClose();
      navigate("/login");
      if (response.ok) {
        console.log("Account deleted successfully");
        navigate("/login");

        handleClose();
      } else {
        console.error("Failed to delete account");
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      navigate("/login");

      toast.error(error.response.data.message);
    }
  };

  const handleDeactivate = async () => {
    try {
      const response = await axios.post(
        `/Account/DeactivateAccount?sessionId=${sessionId}`,
        {
          headers: {
            PublicKey,
          },
        }
      );
      console.log("res", response);
      toast.success(response.data.message);
      handleClose();

    } catch (error) {
      console.error("Error deleting account:", error);
      if (error.response && error.response.status === 409) {
        toast.error(error.response.data.message);
        setUnAuthorizeError(error.response.data.message)
        handleunauthModal()
      } else {
        console.error("Error deleting account:", error);

      }

    }
  };

  // ........................................ Enabled or Disabled for Change Password

  const [formChanged, setFormChanged] = useState(false); // Track if form is modified
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newPasswordError, setNewPasswordError] = useState('');


  const handleFieldChange = (setter, value, fieldName) => {
    setter(value);

    // Form ki sari fields ko update karne ke baad validate karein
    const updatedOldPassword = fieldName === "oldpassword" ? value : oldpassword;
    const updatedNewPassword = fieldName === "newpassword" ? value : newpassword;
    const updatedConfirmPassword = fieldName === "confirmpassword" ? value : confirmpassword;

    const isValid = updatedOldPassword.trim() !== "" &&
      updatedNewPassword.trim() !== "" &&
      updatedConfirmPassword.trim() !== "" &&
      validateForm(updatedOldPassword, updatedNewPassword, updatedConfirmPassword);

    setFormChanged(isValid);
  };



  // ...............................CHANGE PASSWORD Start.......................................

  const [oldpassword, setOldPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setconfirmPassword] = useState("");
  const [unAuthorizeError, setUnAuthorizeError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState('')


  const validatePassword = (password) => {
    const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
    return regex.test(password);
  };

  const handleNewPasswordChange = (e) => {
    const password = e.target.value;
    setNewPassword(password);
    if (!validatePassword(password)) {
      setNewPasswordError("Strong passwords must be 8+ characters and include uppercase letters, lowercase letters, numbers, and symbols.");
    } else {
      setNewPasswordError("");
    }

    if (password !== confirmpassword && confirmpassword !== "") {
      setConfirmPasswordError("Passwords do not match.");
    } else if (confirmpassword) {
      setConfirmPasswordError("");
    }
  };


  const validateForm = (oldpassword, newpassword, confirmpassword) => {
    return oldpassword !== "" && newpassword !== "" && confirmpassword !== "";
  };


  const ChangePassword = async (e) => {
    e.preventDefault();

    const responseData2 = {
      sessionId: sessionId,
      oldPassword: oldpassword,
      newPassword: newpassword,
      confirmPassword: confirmpassword,
    };

    if (!validateForm(oldpassword, newpassword, confirmpassword)) {
      toast.error("Please fill all fields!");
      return;
    }

    try {
      setIsSubmitting(true); // Disable button during submission
      setDisplays(true);

      const res = await axios.post("/Account/ChangePassword", responseData2, {
        headers: {
          PublicKey,
        },
      });

      toast.success(res.data.message);

      // Reset fields and form state
      setOldPassword("");
      setNewPassword("");
      setconfirmPassword("");
      setFormChanged(false); // Disable submit button again
      setIsSubmitting(false);
      setDisplays(false);
      // navigate('/SetNewPassword')
    } catch (error) {
      setIsSubmitting(false); // Re-enable button on error
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } if (error.response && error.response.status === 500) {
        toast.error(error.response.data.message);
      } if (error.response && error.response.status === 409) {
        toast.error(error.response.data.message);
        setUnAuthorizeError(error.response.data.message)
        handleunauthModal()
      } else {
        toast.error(error.message);
      }
    }
  };



  //************************ Block Company Start  ************************//
  const [unauthModal, setUnauthModal] = useState(false);
  const handleunauthModal = () => setUnauthModal(true);
  const handlecloseunauthModal = () => setUnauthModal(false);

  // ...............................CHANGE PASSWORD End.......................................

  //   const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [followerListError, setfollowerListError] = useState(false);
  const [followedList, setFollowedList] = useState([]);

  const getFollowedList = () => {
    const data = {
      sessionId: sessionId,
    };
    axios
      .post(`/Feature/GetFollowedCompanies`, data)
      .then((response) => {
        setIsLoading(false);
        console.log("getFollowerList", response.data.responseData);
        const res = response.data.responseData;
        setFollowedList(res);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setfollowerListError(true);
        } else {
          console.log(error);
        }
        setIsLoading(false);
      });
  };
  useEffect(() => {
    getFollowedList();
  }, []);
  console.log("followedList", followedList);

  //   Block Company
  const [blockedList, setBlockedList] = useState([]);

  const getBlockedList = () => {
    const data = {
      sessionId: sessionId,
    };
    axios
      .post(`/Feature/GetBlockedCompanies`, data)
      .then((response) => {
        setIsLoading(false);
        console.log("getFollowerList", response.data.responseData);
        const res = response.data.responseData;
        setBlockedList(res);
        console.log("blockedList", res);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setfollowerListError(true);
        } else {
          console.log(error);
        }
        setIsLoading(false);
      });
  };
  console.log("blockedList", blockedList);

  //   Block Company
  const [blockedCandidateList, setBlockedCandidateList] = useState([]);

  const getBlockedCandidateList = () => {
    const data = {
      sessionId: sessionId,
    };
    axios
      .post(`/Company/GetBlockedCandidates`, data)
      .then((response) => {
        setIsLoading(false);
        console.log("BlockCandidate", response.data.responseData);
        const res = response.data.responseData || null;
        setBlockedCandidateList(res);
        console.log("BlockCandidate", res);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setfollowerListError(true);
          setBlockedCandidateList(null)
        } else {
          console.log(error);
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getBlockedList();
    getBlockedCandidateList();
  }, []);


  //************************ Block Company Start  ************************//
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handlecloseModal = () => setShowModal(false);

  const BlockCandidate = async (id) => {
    const data = {
      sessionId: sessionId,
    };
    try {
      await axios.post(`/Company/BlockCandidate?UID=${id}`, data)
        .then((resData) => {
          console.log("Block Company", resData.data.message);
          toast.success(resData.data.message);
          getBlockedCandidateList()
          handlecloseModal()
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        toast.error(e.response.data.message);
        handlecloseModal()

      } else {
        toast.error(e.response.data.message);
      }
    }
  };

  const handleConfirmBlock = () => {
    BlockCandidate();
    // setShowModal(false)

  };

  //************************ Block Company End  ************************//

  //************************ UnBlock Company Start  ************************//

  const UnBlockCandidate = async (id) => {
    const data = {
      sessionId: sessionId,
    };

    try {
      await axios.post(`/Company/UnblockCandidate?UID=${id}`, data)
        .then((resData) => {
          console.log("Block Company", resData.data.message);
          toast.success(resData.data.message);
          getBlockedCandidateList();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        toast.error(e.response.data.message);
      } else {
        toast.error(e.response.data.message);
      }
    }
  };
  //************************ UnBlock Company End  ************************//


  // UnFollow user

  const UnFollowUser = async (id) => {
    const data = {
      sessionId: sessionId,
      compUID: unfollowId,
    };
    try {
      await axios
        .post("/CandidateAction/UnfollowCompany", data)
        .then((resData) => {
          console.log("resDataaaaa", resData);
          getFollowedList();
          setShowUnfllow(false);
          toast.success(resData.data.message);
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        toast.error(e.response.data.message);
      } else {
        toast.error(e.response.data.message);
      }
    }
  };

  // UnFollow user

  const UnBlockUser = async (id) => {

    const data = {
      sessionId: sessionId,
      compUID: unblockId,
    };
    try {
      await axios
        .post("/CandidateAction/UnBlockCompany", data)
        .then((resData) => {
          console.log("unblock user", resData.data.message);
          getBlockedList();
          setShowUnblock(false);
          toast.success(resData.data.message);
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        toast.error(e.response.data.message);
      } else {
        toast.error(e.response.data.message);
      }
    }
  };

  return (
    <>
      <section className="term-section settings ">
        <div className="container">
          <Tabs className="row tf-tab">
            <div className="col-lg-4">
              <TabList className="menu-tab tab-term po-sticky">
                <Tab className="ct-tab">1. Profile </Tab>
                <Tab className="ct-tab">2. Account</Tab>
                <Tab className="ct-tab">3. Change Password</Tab>
                {module === 'Candidate' ?
                  <Tab className="ct-tab">4. Blocked Company</Tab>
                  : module === 'Institution' ? ""
                    : <Tab className="ct-tab">4. Blocked Users</Tab>}

                {module === 'Candidate' ?
                  <Tab className="ct-tab">5. Followed Company</Tab>
                  : ''}

                {module === 'Recruiter' ?
                  <Tab className="ct-tab">5. Associated Companies</Tab>
                  : ''}
              </TabList>
            </div>
            <div className="col-lg-8">
              <div className="content-tab">
                <TabPanel className="term-content animation-tab p-4">
                  {module === "Candidate" ? (
                    <UpdateCandidateProfile />
                  ) : module === "Institution" ? (
                    <UpdateInstituteProfile />
                  ) : module === "Company" ? (
                    <UpdateCompanyProfile />
                  ) : module === "Recruiter" ? (
                    <UpdateRecruiterProfile />
                  ) : (
                    <UpdateCandidateProfile />
                  )}
                </TabPanel>

                <TabPanel className="term-content animation-tab p-4 mb-5">
                  <section className="account-section pt-1">
                    {/* <h6 className="f-600">Manage Account</h6> */}

                    <div className="account-section grayCard  p-3">
                      <h6>Deactivate your account</h6>
                      <p>This will deactivate your account</p>
                      <ul className="ps-0">
                        <li>
                          After successful login, the deactivated account will
                          be activated and accessible or viewable
                        </li>
                      </ul>
                      <button onClick={handleShowDeactivate} className="khojPrimaryBtn" style={{ width: 'fit-content' }}>
                        Deactivate account
                      </button>
                    </div>

                    {/* Delete Account Section */}
                    <div className="account-section grayCard p-3 mt-4">
                      <h6>Delete your account</h6>
                      <p>This will delete your account</p>
                      <ul className="ps-0">
                        <li>
                          You can restore your account if it was deleted by
                          mistake within 45 days after deletion.
                        </li>
                      </ul>
                      <span className="delete-account">
                        <button onClick={handleShow} className="delete-account">Delete account</button>
                      </span>
                    </div>
                  </section>
                </TabPanel>

                <TabPanel className="term-content animation-tab p-4 mb-5">

                  <div className="profile-setting-form changePassword">
                    <div className="ip mb-2">
                      <label>Old password</label>
                      <div className="inputs-group auth-pass-inputgroup d-flex">
                        <input
                          type={showPass ? "text" : "password"}
                          className="input-form password-input"
                          placeholder="Old password"
                          autocomplete="new-password"
                          minLength={8}
                          id="old-password-input"
                          required
                          // onChange={(e) => setOldPassword(e.target.value)}
                          onChange={(e) => handleFieldChange(setOldPassword, e.target.value, "oldpassword")}
                          onPaste={(e) => handleFieldChange(setOldPassword, e.clipboardData.getData("text"), "oldpassword")}
                          //value={oldpassword}
                          invalid={displays && oldpassword === ""}
                        />
                        {displays && !oldpassword ? (
                          <span className="error_msg_lbl text-red">
                            Enter old password{" "}
                          </span>
                        ) : null}

                        <Button
                          className={`password-addon mt-0 ${showPass ? "icon-eye" : "icon-eye-off"}`}
                          id="password-addon"
                          style={{ borderRadius: "0px 6px 6px 0px" }}
                          onClick={() => setShowPass(!showPass)}
                        />
                      </div>
                    </div>
                    <div className="ip mb-2">
                      <label>New password</label>
                      <div className="inputs-group auth-pass-inputgroup d-flex">
                        <input
                          type={showPass3 ? "text" : "password"}
                          className="input-form password-input"
                          placeholder="New password"
                          id="password-input"
                          minLength={8}
                          required
                          // onChange={(e) => setNewPassword(e.target.value)}

                          // onChange={handleNewPasswordChange}
                          onChange={(e) => handleFieldChange(setNewPassword, e.target.value, "newpassword")}
                          onPaste={(e) => handleFieldChange(setNewPassword, e.clipboardData.getData("text"), "newpassword")}
                        //value={newpassword}
                        //invalid={displays && newpassword === ""}
                        />
                        {/* {displays && !newpassword ? (
                          <span className="error_msg_lbl text-red">
                            Enter New Password{" "}
                          </span>
                        ) : null} */}

                        <Button
                          className={`password-addon mt-0 ${showPass3 ? "icon-eye" : "icon-eye-off"
                            }`}
                          id="password-addon"
                          style={{ borderRadius: "0px 6px 6px 0px" }}
                          onClick={() => setShowPass3(!showPass3)}
                        />
                      </div>

                    </div>
                    <div> {newPasswordError && <span className='error_msg_lbl text-red'>{newPasswordError}</span>}</div>
                    <div className="ip">
                      <label>Confirm password</label>
                      <div className="inputs-group auth-pass-inputgroup d-flex">
                        <input
                          type={showPass1 ? "text" : "password"}
                          className="input-form password-input"
                          placeholder="Confirm password"
                          id="password-input"
                          required
                          minLength={8}
                          // onChange={(e) => setconfirmPassword(e.target.value)}
                          onChange={(e) => handleFieldChange(setconfirmPassword, e.target.value, "confirmpassword")}
                          onPaste={(e) => handleFieldChange(setconfirmPassword, e.clipboardData.getData("text"), "confirmpassword")}
                          //value={confirmpassword}
                          invalid={displays && confirmpassword === ""}
                        />
                        {/* {displays && !confirmpassword ? (
                          <span className="error_msg_lbl text-red">
                            Enter Confirm Password{" "}
                          </span>
                        ) : null} */}

                        <Button
                          className={`password-addon mt-0 ${showPass1 ? "icon-eye" : "icon-eye-off"
                            }`}
                          id="password-addon"
                          style={{ borderRadius: "0px 6px 6px 0px" }}
                          onClick={() => setShowPass1(!showPass1)}
                        />
                      </div>
                    </div>

                    <button
                      // className="btn btn-primary"
                      onClick={(e) => ChangePassword(e)}
                      className={`btn btn-primary  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                      // onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
                      disabled={!formChanged || isSubmitting}
                      style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
                    >
                      Submit
                    </button>
                  </div>
                </TabPanel>



                <TabPanel className="term-content animation-tab p-4 mb-5">
                  {module === 'Candidate' || module === 'Institution' ?
                    <section className="account-section pt-1">
                      {/* <h6 className="f-600">Blocked Users</h6> */}

                      {
                        blockedList && blockedList.filter((item) => !item.isDeleted).length > 0 ? (
                          blockedList
                            .filter((item) => !item.isDeleted)
                            .map((item) => {
                              return (
                                <div className="col-lg-12" key={item.compUid}>
                                  <div className="employer-block style-2">
                                    <div className="inner-box">
                                      <div className="logo-company">
                                        <img
                                          src={item.logo}
                                          alt="User Logo"
                                          style={{ borderRadius: "50%" }}
                                        />
                                      </div>
                                      <div className="box-content">
                                        {item.title === "Company" ? (
                                          <h3>
                                            <Link to={`/Company/${item.compUid}`}>
                                              {item.compName}
                                            </Link>
                                          </h3>
                                        ) : (
                                          <h3>
                                            <Link to={`/Recruiter/${item.compUid}`}>
                                              {item.compName}
                                            </Link>
                                          </h3>
                                        )}

                                        <p className="info">{item.title}</p>
                                      </div>
                                      <div className="button-readmore">
                                        <button
                                          className="btn-employer"
                                          onClick={() => {
                                            handleShowUnblock();
                                            setUnblockId(item.compUid);
                                          }}
                                        >
                                          Unblock
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                        ) : (
                          <div className="col-lg-12">
                            <div className="no-records d-flex justify-content-center pt-4">
                              <p>There are no records to display</p>
                            </div>
                          </div>
                        )
                      }
                    </section>
                    :
                    <section className="account-section pt-1">

                      {
                        blockedCandidateList && blockedCandidateList.filter((item) => !item.isDeleted).length > 0 ? (
                          blockedCandidateList
                            .filter((item) => !item.isDeleted)
                            .map((item) => {
                              return (
                                <div className="col-lg-12" key={item.compUid}>
                                  <div className="employer-block style-2">
                                    <div className="inner-box d-flex align-item-center justify-content-center">
                                      <div className="logo-company">
                                        <img
                                          src={item.profileImage}
                                          alt="User Logo"
                                          style={{ borderRadius: "50%" }}
                                        />
                                      </div>
                                      <div className="box-content">
                                        <p className="info mb-0 f-12">{item.email}</p>
                                        <h3 className="mb-0">
                                          <Link to={`/Company/${item.cnddtUID}`}>
                                            {item.firstName} {item.lastName}
                                          </Link>
                                        </h3>
                                        <div className="d-flex align-item-center">
                                          {item.cityName === null ? "" : (

                                            <div className="d-flex me-3 align-item-center">
                                              <span class="icon-map-pin me-1 f-14"></span><p className="info mb-0">{item.cityName}</p>
                                            </div>
                                          )}
                                          {item.genderName === null ? "" : (
                                            <div className="d-flex align-item-center">
                                              <span> <WcOutlinedIcon className="me-1 f-14" /> </span><p className="info mb-0">{item.genderName}</p>
                                            </div>
                                          )}


                                        </div>
                                      </div>
                                      <div className="button-readmore">
                                        <button
                                          className="btn-employer"
                                          onClick={() => {
                                            UnBlockCandidate(item.cnddtUID);
                                          }}
                                        >
                                          Unblock
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                        ) : (
                          <div className="col-lg-12">
                            <div className="no-records d-flex justify-content-center pt-4">
                              {/* <p>There are no records to display</p> */}
                              <p>No blocked candidates found!</p>
                            </div>
                          </div>
                        )
                      }
                    </section>
                  }

                </TabPanel>


                {module === 'Candidate' || module === 'Institution' ?
                  <TabPanel className="term-content animation-tab p-4 mb-5">
                    <section className="account-section pt-1">
                      {/* <h6 className="f-600">Followed Users</h6> */}
                      {
                        followedList && followedList.filter((item) => !item.isDeleted).length > 0 ? (
                          followedList

                            .filter((item) => !item.isDeleted)
                            .map((item) => {
                              return (
                                <div className="col-lg-12">
                                  <div className="employer-block style-2">
                                    <div className="inner-box">
                                      <div className="logo-company">
                                        <img
                                          //   src={item.logo}
                                          src={item.logo}
                                          alt="User Logo"
                                          style={{ borderRadius: "50%" }}
                                        />
                                      </div>
                                      <div className="box-content">
                                        {item.title === "Company" ? (
                                          <h3>
                                            <Link to={`/Company/${item.compUid}`}>
                                              {item.compName}
                                            </Link>
                                          </h3>
                                        ) : (
                                          <h3>
                                            <Link to={`/Recruiter/${item.compUid}`}>
                                              {item.compName}
                                            </Link>
                                          </h3>
                                        )}

                                        <p className="info">
                                          {item.title}

                                          {/* <span className="icon-map-pin"></span> */}
                                        </p>
                                      </div>
                                      <div className="button-readmore">
                                        <button
                                          className="btn-employer"
                                          onClick={() => {
                                            handleShowUnfollow()
                                            setUnfollowId(item.compUid)
                                          }

                                          }
                                        >
                                          {" "}
                                          Unfollow
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                        ) : (
                          <div className="col-lg-12">
                            <div className="no-records d-flex justify-content-center pt-4">
                              <p>There are no records to display</p>
                            </div>
                          </div>
                        )
                      }

                    </section>
                  </TabPanel>
                  : ''}

                {module === "Recruiter" ? (
                  <TabPanel className="term-content animation-tab p-4">
                    <ManageComList />
                  </TabPanel>
                ) : (
                  ''
                )}
              </div>
            </div>
          </Tabs>
        </div>
      </section>

      {/* ...............................Deactivate modal Start....................................... */}

      <Modal show={showDeactivate} onHide={handleClose} centered>
        <Modal.Header >
          <Modal.Title>Confirm Deactivation</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Are you sure you want to deactivate your account?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleDeactivate} className="btn btn-danger me-2">
            Confirm Deactivate
          </button>
          <button onClick={handleClose} className="btn btn-secondary">
            Cancel
          </button>
        </Modal.Footer>
      </Modal>


      {/* ...............................Delete modal Start....................................... */}

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header >
          <Modal.Title>Confirm delete</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Are you sure you want to delete your account?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleDelete} className="btn btn-danger me-2">
            Confirm delete
          </button>
          <button onClick={handleClose} className="btn btn-secondary">
            Cancel
          </button>
        </Modal.Footer>
      </Modal>


      {/* ...............................Unblock modal Start....................................... */}

      <Modal show={showUnblock} onHide={handleCloseUnblock} centered>
        <Modal.Header >
          <Modal.Title>Confirm Unblock</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseUnblock} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Are you sure want to unblock?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={UnBlockUser} className="btn btn-danger me-2">
            Confirm unblock
          </button>
          <button onClick={handleCloseUnblock} className="btn btn-secondary">
            Cancel
          </button>
        </Modal.Footer>
      </Modal>


      {/* ...............................Unfollow modal Start....................................... */}

      <Modal show={showUnfollow} onHide={handleCloseUnfollow} centered>
        <Modal.Header >
          <Modal.Title>Confirm Unfollow</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseUnfollow} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Are you sure want to unfollow?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={UnFollowUser} className="btn btn-danger me-2">
            Confirm Unfollow
          </button>
          <button onClick={handleCloseUnfollow} className="btn btn-secondary">
            Cancel
          </button>
        </Modal.Footer>
      </Modal>

      {/* ...............block modal............  */}
      <Modal show={showModal} onHide={handlecloseModal} centered>
        <Modal.Header>
          <Modal.Title>Confirm Block</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handlecloseModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Are you sure you want to block Company</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Confirm</button>
          {/* <button onClick={handleClose} className="btn btn-secondary">Cancel</button> */}

        </Modal.Footer>

      </Modal>

      {/* ...............UnAuthorize modal............  */}
      {unAuthorizeError ? (
        <Modal show={unauthModal} centered>
          <Modal.Header>
            <Modal.Title>Unauthorize session expired</Modal.Title>
          </Modal.Header>
          <Modal.Body className="settings">
            <div className=" mb-3">
              <p>{unAuthorizeError}</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Link
              className="pointer"
              to="/Login"
              onClick={() => {
                localStorage.removeItem("token"); // Remove authentication token
                sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
                localStorage.removeItem("Module");
              }}
            >
              <button className="btn btn-danger ">Login</button>
            </Link>
            {/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}

          </Modal.Footer>

        </Modal>
      ) : (
        ""
      )}

    </>
  );
};

export default Setting;
